var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooterAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 527.85 180.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8d6321;}.cls-2{fill:#ac831d;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LogoFooterArAsset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.68,0l-.07,9.76-37,13a.27.27,0,0,1-.34-.17.25.25,0,0,1,0-.08l0-9a.43.43,0,0,1,.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.68,0l55.46,19.58a.54.54,0,0,1,.4.56v8.91q0,.4-.39.27L433.61,9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.6,13.92l.15,9.72L396.59,36.71a.26.26,0,0,1-.34-.15.29.29,0,0,1,0-.09V27.54a.57.57,0,0,1,.41-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.6,13.92l55.28,19.54a.89.89,0,0,1,.66.92V139.79c0,.61-.29.81-.86.61l-55-19.34.19-9.72,45.35,16c.47.16.7,0,.7-.5V68.68a1.09,1.09,0,0,0-.78-1.12l-40.4-14.22a.93.93,0,0,1-.68-1V30.11a.5.5,0,0,1,.51-.51.57.57,0,0,1,.18,0l36.26,12.8a.48.48,0,0,1,.31.45l0,9c0,.25-.12.34-.36.26L448.34,42.8c-.44-.16-.67,0-.67.47V46a1,1,0,0,0,.71,1l30.9,10.89a.52.52,0,0,0,.65-.32.47.47,0,0,0,0-.17V40.74a1,1,0,0,0-.7-1L433.75,23.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.87,55.73l-.22,9.69-37,13a.24.24,0,0,1-.32-.16.19.19,0,0,1,0-.08l0-9.07a.46.46,0,0,1,.31-.44l27-9.52a1.1,1.1,0,0,0,.74-1l0-2.57c0-.54-.25-.71-.75-.54l-26.7,9.43c-.38.13-.57,0-.57-.41l0-22.44a.9.9,0,0,1,.59-.84L433.1,28c.49-.17.74,0,.74.53Zm-28.09-4.87a.47.47,0,0,0,.44.49.4.4,0,0,0,.19,0l17.52-6.22a.48.48,0,0,0,.32-.44V41.52a.47.47,0,0,0-.47-.47.37.37,0,0,0-.15,0l-17.4,6.13a.46.46,0,0,0-.31.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.75,
    y: 39.66,
    width: 9.56,
    height: 8.88,
    rx: 0.44,
    ry: 0.44,
    transform: "translate(-26.63 61.48) rotate(-89.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.15,
    y: 39.66,
    width: 9.56,
    height: 8.88,
    rx: 0.41,
    ry: 0.41,
    transform: "translate(-14.27 73.88) rotate(-89.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.18,87.47l24.33.13a.65.65,0,0,0,.74-.73V40a.32.32,0,0,1,.36-.36h10.64a.35.35,0,0,1,.35.36V97.43a.62.62,0,0,1-.69.71q-21.71.19-32,0a44.91,44.91,0,0,1-15.22-3.19,1.9,1.9,0,0,0-1.35,0,47.08,47.08,0,0,1-15.53,3.22q-15.34.15-31,.06c-.26,0-.39-.12-.39-.37V40a.32.32,0,0,1,.36-.36h11a.32.32,0,0,1,.35.36V86.86a.64.64,0,0,0,.73.72l22,0c1.85,0,2.07-.63.68-1.85-4.08-3.59-9.69-9.26-10.07-15q-.28-4.37-.36-8.43a1.14,1.14,0,0,1,.6-1q21.9-12,44.6,0a1.59,1.59,0,0,1,.81,1.69,23.29,23.29,0,0,0-.41,5.37c.31,7.87-5.86,13.07-11,18C281.89,87.06,282,87.46,283.18,87.47Zm-.46-18.41a1.17,1.17,0,0,0-.73-1.48h0a33.93,33.93,0,0,0-20.94-.3,1.84,1.84,0,0,0-1.32,2.79A24.17,24.17,0,0,0,270.25,82a1.33,1.33,0,0,0,1.46,0Q280,77.06,282.72,69.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.25,
    y: 39.66,
    width: 11.35,
    height: 58.55,
    rx: 0.57,
    ry: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.31,87.56H83.69a.63.63,0,0,0,.71-.71V57.05a.62.62,0,0,1,.71-.71H95.4a.63.63,0,0,1,.71.71v40.4a.65.65,0,0,1-.74.73q-33.6.06-70.49,0c-11.22,0-22.49-.43-24.4-14.66a52.71,52.71,0,0,1,0-14.36Q2.26,56.6,16.09,55.73a154.87,154.87,0,0,1,26.55.69.63.63,0,0,1,.62.7V86.49A.94.94,0,0,0,44.31,87.56ZM32,86.46l0-19.38a1.15,1.15,0,0,0-1.15-1.15l-10.71,0a8.32,8.32,0,0,0-8.45,8.16h0v5.34a8.31,8.31,0,0,0,8.42,8.19H30.8A1.14,1.14,0,0,0,32,86.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.63,99.06q-2.31,16.53-19.8,14.63a.44.44,0,0,1-.45-.49v-9.68c0-.29.15-.42.44-.38q8.37,1.22,8.4-8.4.06-20.7,0-37.77a.56.56,0,0,1,.64-.63h10a.62.62,0,0,1,.7.71v29.8a.71.71,0,0,0,.71.71h45.37q.94,0,.75-.93-2.53-12.27,1.73-27.21a2.69,2.69,0,0,1,2-2,52.25,52.25,0,0,1,22.42-1.33q12.49,2,13.31,15.41.54,9,.19,26a.62.62,0,0,1-.7.68H127.62A.89.89,0,0,0,126.63,99.06ZM201.82,86.6c.26-13.14,1.52-23.25-16.41-20.27a.85.85,0,0,0-.78.76,54.11,54.11,0,0,0,0,19.78.76.76,0,0,0,.83.69h15.45A.86.86,0,0,0,201.82,86.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.87,55.73l40.69,14.34a1.1,1.1,0,0,1,.79,1.12V93.6a.31.31,0,0,1-.3.3l-.09,0-8.87-3.06a.48.48,0,0,1-.32-.44V77.59a1.05,1.05,0,0,0-.78-1.08L433.65,65.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.68,69.55l-.08,9.76-37,13.06a.27.27,0,0,1-.33-.16.28.28,0,0,1,0-.09l0-9.11a.35.35,0,0,1,.27-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.68,69.55l27.18,9.68a1,1,0,0,1,.65.9V116c0,.62-.29.82-.87.61l-26.84-9.42.52-9.44,17.26,6c.22.08.34,0,.34-.24V100a.53.53,0,0,0-.34-.48l-17.43-6.2,0-9.29,17.56,5.84c.11,0,.17,0,.17-.11l.12-3.62a.49.49,0,0,0-.35-.52l-18-6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.12,84l0,9.29q-.88,2.81.17,4.44l-.52,9.44-9,3a.5.5,0,0,1-.62-.32.77.77,0,0,1,0-.15l.1-12.33q0-.89-.81-.6l-26.89,9.44c-.24.08-.36,0-.36-.26V97.08a.56.56,0,0,1,.41-.58q18.15-6.39,36.49-12.88Q434.23,83.25,434.12,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.72,107.75l-8.63-3a.47.47,0,0,1-.32-.45l0-8.81a.49.49,0,0,1,.48-.49.57.57,0,0,1,.18,0L475,98.13a.48.48,0,0,1,.31.45l0,8.71a.48.48,0,0,1-.49.48A.39.39,0,0,1,474.72,107.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.38,105.59l9-3.18a.48.48,0,0,1,.63.46l0,8.75a.46.46,0,0,1-.32.44l-9,3.18a.47.47,0,0,1-.6-.28.55.55,0,0,1,0-.17l0-8.76A.46.46,0,0,1,410.38,105.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 74.46,
    y: 104.24,
    width: 8.85,
    height: 9.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-0.38 0.28) rotate(-0.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.24,
    y: 104.23,
    width: 8.85,
    height: 9.59,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-0.38 0.32) rotate(-0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.63,110.44l8.42-3a.58.58,0,0,1,.74.35.65.65,0,0,1,0,.19l0,8.5a.59.59,0,0,1-.39.56L397,120a.58.58,0,0,1-.75-.35.44.44,0,0,1,0-.2l0-8.47A.58.58,0,0,1,396.63,110.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.72,121.65l-8.61-3a.47.47,0,0,1-.33-.45l0-8.74a.48.48,0,0,1,.49-.48l.15,0,8.63,3a.51.51,0,0,1,.33.46v8.75a.48.48,0,0,1-.49.48A.4.4,0,0,1,474.72,121.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.91,111.34l-.19,9.72-37.13,13.07a.23.23,0,0,1-.31-.16.19.19,0,0,1,0-.08l0-9a.43.43,0,0,1,.33-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.7,125.26l-.1,39.26c-25.18.6-51.67,4.8-74.6,15.51-.94.44-1.07.26-.4-.52a25.63,25.63,0,0,1,5.28-4.66,93,93,0,0,1,31.59-13.25,1,1,0,0,0,.76-.95V139.27a1.11,1.11,0,0,1,.8-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.7,125.26l55.17,19.51a1,1,0,0,1,.67.94v14.9a1,1,0,0,0,.78,1c12.48,2.86,27.26,8.45,36.57,17.54,1.43,1.39,1.26,1.63-.53.73a96.36,96.36,0,0,0-12-4.93q-24.72-8.49-56.39-10.12a236.91,236.91,0,0,0-24.36-.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 328.46,
    y: 126.51,
    width: 3.21,
    height: 3.77,
    rx: 1.09,
    ry: 1.09,
    transform: "translate(-0.22 0.58) rotate(-0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.18,140.77q39,0,54.52,0c2.55,0,5.06.1,6.31,2.77,2,4.2,1.44,9,1.42,13.44a.73.73,0,0,1-.82.81q-37.33.06-87.9,0a6.13,6.13,0,0,1-3.18-.91c-4.27-2.51-4.23-7.05-3.91-11.56q.51-7.29,7.62-7.58a69.36,69.36,0,0,1,9.55.34.57.57,0,0,1,.58.64v15.54a.62.62,0,0,0,.69.71l71,.22c2.49,0,3.52-1.22,3.11-3.67-.22-1.34-.44-2.67-.67-4a4.19,4.19,0,0,0-4.6-3.89H230.25a2.8,2.8,0,0,1-2.78-2.79,2.89,2.89,0,0,1,.28-1.2,46.94,46.94,0,0,1,5.85-9.2,1.33,1.33,0,0,1,1.91-.35l.34.21a1.06,1.06,0,0,1,.38,1.44h0l-4.68,7.92C231.1,140.4,231.32,140.77,232.18,140.77Zm-19,13.08,0-12.09a1,1,0,0,0-1.05-1h0l-4.48,0a6,6,0,0,0-5.81,6.09v2.07a6,6,0,0,0,5.88,6h0l4.49,0A1,1,0,0,0,213.23,153.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 59.91,
    y: 131.19,
    width: 3.55,
    height: 3.55,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(-3.46 1.66) rotate(-1.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 64.72,
    y: 131.39,
    width: 3.58,
    height: 3.18,
    rx: 0.74,
    ry: 0.74,
    transform: "translate(-68.72 194.8) rotate(-88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.31,
    y: 131.19,
    width: 3.21,
    height: 3.55,
    rx: 0.71,
    ry: 0.71,
    transform: "translate(-3.65 4.27) rotate(-1.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 204.48,
    y: 131.36,
    width: 3.55,
    height: 3.24,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(67.57 335.44) rotate(-88.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 209.27,
    y: 131.23,
    width: 3.58,
    height: 3.49,
    rx: 0.79,
    ry: 0.79,
    transform: "translate(70.44 339.03) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 325.96,
    y: 131.15,
    width: 3.24,
    height: 3.63,
    rx: 1.04,
    ry: 1.04,
    transform: "matrix(1, -0.04, 0.04, 1, -5.28, 13.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 330.96,
    y: 131.22,
    width: 3.24,
    height: 3.55,
    rx: 0.88,
    ry: 0.88,
    transform: "translate(-5.48 14.63) rotate(-2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.51,153.9a.94.94,0,0,0,1.07,1.06h7.79c.92,0,1.32-.46,1.17-1.38-1-6.38,4.89-10.61,10.76-7.76,3.29,1.6,3.53,5.05,3.28,8.29-.05.57.21.85.78.85h4.2a.69.69,0,0,0,.77-.72c.38-6.77-.39-14.14-8.9-14.68a29.62,29.62,0,0,0-8.84.85.74.74,0,0,1-.9-.54v0l-.23-1.19a.74.74,0,0,1,.58-.95c8.76-2.48,20.47-2,21.29,9.35a89.54,89.54,0,0,1,.14,10.39.36.36,0,0,1-.39.37H124.83a.63.63,0,0,1-.71-.73v-1.4a.63.63,0,0,1,.71-.71h11.31a.79.79,0,0,0,.78-.77c.19-6.36-.48-15.48-9.79-13.65a.72.72,0,0,1-.84-.56l-.28-1.34a.86.86,0,0,1,.82-1.18c11.91-1.63,13.7,6.7,13.2,16.42a.9.9,0,0,0,1,1.09h6.84a1.26,1.26,0,0,0,1.42-1.42V138.64a.64.64,0,0,1,.72-.72l2.12,0a.31.31,0,0,1,.35.34ZM166.13,155H173a.5.5,0,0,0,.5-.5V153c0-2.83-1.68-5.13-3.75-5.13h-.32c-2.08,0-3.76,2.3-3.76,5.13v1.47A.49.49,0,0,0,166.13,155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.81,154.61V140.77a.64.64,0,0,1,.71-.71h2.13a.63.63,0,0,1,.71.71v12.08q0,3,2.85,2.07l.9-.29a4,4,0,0,0,3-4.13v-9.73a.62.62,0,0,1,.71-.71H110a.75.75,0,0,1,.74.77h0l-.34,12.25a1.22,1.22,0,0,0,1.16,1.37l4.29.67c.72.1,1.1-.2,1.13-.92a79.06,79.06,0,0,0-.71-14.92,1,1,0,0,1,.78-1.06l1.11-.17a.86.86,0,0,1,1.11.79,75.84,75.84,0,0,1,.84,18.15.78.78,0,0,1-.87.8l-7.46,0a3.33,3.33,0,0,1-1.84-.54,2.16,2.16,0,0,0-2.66.08,2.44,2.44,0,0,1-1.49.49l-44.43,0c-4.12,0-6.93-3.57-7.27-7.5-.48-5.78.14-12.5,7.64-12.56q4.42,0,9.4.28a.8.8,0,0,1,.84.9v15.35a.71.71,0,0,0,.71.71h8.52a.62.62,0,0,0,.7-.71V138.6a.64.64,0,0,1,.76-.71l1.76.06a.71.71,0,0,1,.68.72l0,15.94a.37.37,0,0,0,.37.35h11A.35.35,0,0,0,96.81,154.61Zm-28-.53-.06-12.49a.85.85,0,0,0-.86-.86h0l-4.62,0a5.79,5.79,0,0,0-5.86,5.73l0,2.81A5.78,5.78,0,0,0,63.35,155h0L68,155A.87.87,0,0,0,68.83,154.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.19,154.61V140.77a.62.62,0,0,1,.71-.7H321a.63.63,0,0,1,.71.71v12.08q0,3,2.86,2.07l.72-.23a4.18,4.18,0,0,0,3.16-4.36v-9.56a.63.63,0,0,1,.71-.71H331a.73.73,0,0,1,.73.72l-.09,13.06a.45.45,0,0,0,.37.44l5.21.86c.5.09.76-.12.79-.62a118.26,118.26,0,0,0-.28-15.11,1.17,1.17,0,0,1,1-1.27l.42-.07a1.2,1.2,0,0,1,1.55,1.11,77.84,77.84,0,0,1,.88,17.88.56.56,0,0,1-.55.58,22.91,22.91,0,0,1-10.8-.81,1.37,1.37,0,0,0-1.2.1,7.09,7.09,0,0,1-3.8.95q-9-.18-16.81-.07a.81.81,0,0,0-.9.94c.06,5.16-2,9.59-8.23,8.61a1.65,1.65,0,0,1-1.52-2.14.77.77,0,0,1,.91-.75c3.62.23,5.42-1.61,5.39-5.54q-.06-10,0-20.2,0-.42.39-.42l2.43,0a.63.63,0,0,1,.72.71v15.63a.36.36,0,0,0,.36.35h9.93A.36.36,0,0,0,318.19,154.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.26,
    y: 160.75,
    width: 3.55,
    height: 3.26,
    rx: 0.82,
    ry: 0.82,
    transform: "translate(-84.6 236.55) rotate(-87.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.4,
    y: 160.57,
    width: 3.18,
    height: 3.63,
    rx: 0.89,
    ry: 0.89,
    transform: "translate(-7 3.91) rotate(-2.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterAr);
export default __webpack_public_path__ + "static/media/LogoFooterAr.5c3fce9d09bf32cccf7f3ce13b9a14e8.svg";
export { ForwardRef as ReactComponent };